import './index.scss'
import { FC } from 'react'

import Table, { TableProps } from './AppTable'
import FilterButton from './FilterButton'
import FilterSection from './FilterSection'
import TableDefaultButton from './TableDefaultButton'
import TableFilterContainer from './TableFilterContainer'
import TableFilterHeader from './TableFilterHeader'
import TableWrapper from './TableWrapper'

interface TableComponent extends FC<TableProps> {
  FilterContainer: typeof TableFilterContainer
  FilterButton: typeof FilterButton
  FilterHeader: typeof TableFilterHeader
  DefaultButton: typeof TableDefaultButton
  FilterSection: typeof FilterSection
}

const AppTable = Table as TableComponent
AppTable.FilterContainer = TableFilterContainer
AppTable.FilterHeader = TableFilterHeader
AppTable.FilterSection = FilterSection
AppTable.FilterButton = FilterButton
AppTable.DefaultButton = TableDefaultButton

export { AppTable, TableWrapper }
